export default "__VITE_ASSET__Be5V6a8f__"